import React from "react";
import "./styles.css";

const GDP = () => {
  return (
    <div className="container">
      <h1>Gross Domestic Product</h1>
      <p>Gross Domestic Product, represents the total amount of economic activity within an economy over the period of one year. This can be measured as the total of all spending within the economy, total income earned within the economy, or as value added.</p>
      <h2>Real and Nominal GDP</h2>
      <p>Real GDP, is a measure of GDP adjusted to inflation. Nominal GDP, is a measure of GDP as it is. The difference between Real, and Nominal GDP can be derived by looking at the Implicit Deflator, which indicates how much of GDP is due to actual production, and how much is due to the inflation of prices.</p>
      <img src="assets/implicit_deflator.png" alt="GDP Implicit Deflator" />
      <h2>Actual, and Potential GDP</h2>
      <p>Actual GDP, is a measure of the actual production within the economy. Potential GDP, is what could have been produced within an economy, over the period of one year, given all available resource factors of production.</p>
      <p>If Actual GDP, is more than Potential GDP, this is an indication that the economy is subject to inflation. If Actual GDP, is less than Potential GDP, this is an indication that the economy is subject to deflation. Resources that are not utilized when an economy is in deflation represent the Dead Weight Loss of Unemployment.</p>
      <img src="assets/gdp.png" alt="Gross Domestic Product" />
      <p>GDP spending based has the following components:</p>
      <ul>
        <li>Consumption Expenditure, which is the total spending by all individual consumers within the economy;</li>
        <li>Investment Expenditure, which is the total amount of investment within the economy;</li>
        <li>Government Spending, which is the total amount of government spending within the economy; and</li>
        <li>Net Exports, which is the difference between total Exports, and Imports</li>
      </ul>
      <p>Investment Expenditure, has the following components:</p>
      <ul>
        <li>Investment in inventory;</li>
        <li>Investment in fixed capital formation; and</li>
        <li>Investment in residential housing construction.</li>
      </ul>
      <p>Government Spending has to be understood in the context of Net Taxes:</p>
      <img src="assets/government_spending.png" alt="Government Spending" />
      <p>Where:</p>
      <ul>
        <li><strong>G</strong> represents Government Spending;</li>
        <li><strong>T</strong> stands for Transfer Payments, which is a category of Government Spending, such as pensions for Government servants, that has an accountable benefit to society; and</li>
        <li><strong>G<sub>Net</sub></strong> is the difference between Total Tax Income, and Government Spending that cannot be accounted for to have a measurable effect.</li>
      </ul>
      <img src="assets/aggregate_expenditure.png" alt="Aggrigate Expenditure" />
      <p>Whenever Aggregate Expedition, is more than GDP, the economy is subject to inflation. The overspending is possible either by running down savings, or borrowing.</p>
      <p>Whenever Aggregate Expenditure is less than GDP, the economy is subject to deflation. The excess income is converted in to positive savings.</p>
      <p>The 45° line represents an equilibrium, where Total Aggregate Expenditure equals Actual Output.</p>
      <h2>GDP as an Aggregate of Total Income</h2>
      <p>When GDP is measured as an aggregate of Total Income, we consider the following:</p>
      <ul>
        <li>All wage earned by the labor force;</li>
        <li>Rent collected by land lords;</li>
        <li>Dividends earned on corporate investments; and</li>
        <li>Interest earned on savings.</li>
      </ul>
      <h2>GDP as Value Added</h2>
      <p>GDP as Value Added, represents the total amount of value created by all economic activity within and economy, over the period of one year.</p>
      <img src="assets/value_added.png" alt="GDP as Value Addeed" />
      <h2>GDP, GNP, and GNI</h2>
      <p>GDP, or Gross Domestic Product, is the total amount of all economic activity within an economy, over the period of one year.</p>
      <p>GNP, or Gross National Product, is the total amount of all economic activity generated within the national economy, within a period of one year.</p>
      <p>GNI, or Gross National Income, is the total income earned by the national economy, within a period of one year.</p>
      <p><i>Note that by national economy, what is meant is not only territoriality, but also what is produced, and earned by nationals of that economy, whether within the State territory, or abroad, and repatriated.</i></p>
    </div>
  );
};

export default GDP;